import React, {Component} from 'react';
import CONSTANTS from '../../config/constants'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faQuestionCircle, faPlusCircle} from '@fortawesome/pro-regular-svg-icons';
import {structure, single} from '../../../core/store/actions/block'
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import {connect} from 'react-redux';
import _ from 'lodash';

class FaqBlock extends Component {
    getContentFieldValue = (fieldDefinitionKey, contents = false) => {
        const {contentFields} = this.props;
        const items = contents ? contents : contentFields;
        const data = _.find(items, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;

        let w = 60;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    render() {
        const {relatedContents} = this.props;

        const items = relatedContents.map(item => {
            return {
                question: this.getContentFieldValue('Question', item.contentFields),
                answer: this.getContentFieldValue('Answer', item.contentFields)
            };
        });

        return (
            <section className={"faq w--" + this.getBlockWidth() + " show--shadow"}>
                <section className="faq--inner">
                    <div className="inner-wrapper inner-wrapper--faq">
                        <div className="title-section">
                            <h3>
                                <span><FontAwesomeIcon icon={faQuestionCircle}/></span>
                                <em>{this.getContentFieldValue('Title')}</em>
                            </h3>
                            <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
                                {items.map((faq, key) => {
                                    return (
                                        <AccordionItem key={key}>
                                            <AccordionItemHeading>
                                                <AccordionItemButton>
												<span className="plus-icon">
													<FontAwesomeIcon icon={faPlusCircle}/>
												</span>
                                                    <em>{faq.question}</em>
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel>
                                                <div dangerouslySetInnerHTML={{__html: faq.answer}}>
                                                </div>
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    )
                                })}
                            </Accordion>
                        </div>
                    </div>
                </section>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        content: state.content,
        language: state.language
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        structure: (workspace) => dispatch(structure(workspace)),
        single: (id, lang) => dispatch(single(id, lang)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FaqBlock);


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/FaqBlock.js